import React, { Component, useState, useEffect } from "react";
import ActionItem from "../ActionItem";
import CardComponent, { SFCard } from "../MessageComponents/CardComponent";
import MessageFeedback from "../MessageFeedback";
import JsxParser from "react-jsx-parser";
import MDUtil from "../../../Utils/MDUtil";
import LoginButton, {
  Button,
} from "../../BaseComponents/LoginScreen/LoginButton";
import HandleWorkflowJson from "./HandleWorkflowJson";

import WorkflowsMenu from "../../BaseComponents/WorkflowsMenu";

import rblLogo from "../../../../assets/imgs/RBL_cares_logo.svg";
import searchIcon from "../../../../assets/imgs/search.svg";
import editIcon from "../../../../assets/imgs/edit.svg";
import getImg from "./../../../Utils/getImg";
import styled from "styled-components";
import KYCAppointment from "../WorkFlows/KYCAppointment";
import KYCFileUpload from "../WorkFlows/KYCFileUpload";
import Axios from "axios";
import { wrapperEndPoint } from "../../../Utils/Api";
import ReSubmit from "../WorkFlows/ReSubmit";

interface IProps {
  handleSubmit;
  chatMessages;
  quickLinks;
  data;
  toggleLoginScreen;
  isWelcomeScreenVisible;
  logoImagePath;
  BbpsFlag;
  NoConfirmButton;
  overlayRechargeToggle;
  overlayMessageToggle;
  overlayImageModalToggle;
  isPushBotVisible;
  logoutUser;
  transactionResponseAarry;
  storeChecklist;
  overlayIFSCInputToggle;
  userSelectedIFSCCode;
  userSelectedBankName;
  userSelectedId;
  userSelectedAddress;
  handleQuickLinkSubmit;
  toggleGeneralOverlay;
  CNCLinksOnClick;
  setWorkflowName;
  checkBoxJsonData;
  checkBoxFlag;
  termsCheckBox;
  termsCheckBoxFlag;
  termsText;
  termsLink;
  addServerResponse;
  showRewardCalender;
  removeFeedbackOption;
}

function parseJSON(message) {
  try {
    return JSON.parse(
      message.replace(/<p>.*?<\/p>/, "").replace(/<i .*>.*<\\?\/i>/g, "")
    );
  } catch (e) {
    try {
      return JSON.parse(
        message
          .replace(/<p>.*?<\/p>/, "")
          //.replace(/<span.*class='apiresponsesplitter'>.*<\\?\/i>/,"")
          .replace(/<span.*class='apiresponsesplitter'>.*/, "")
      );
    } catch (e) {
      console.log("SFJSONParser -> parser error");
      return "Incorrect answer format";
    }
  }
}

let DangerousMessage = (props) => {
  var messedMessage =
    props.message.indexOf("<p>#SF#") === 0
      ? parseJSON(props.message)
      : props.message;
  let val = null;
  if (
    props.taskName === "Infobot Multichoice" ||
    props.taskName === "card pin options"
  ) {
    if (props.message.includes("Workflow-link")) {
      val = props.message;
      while (val.includes("<br/>") || val.includes("<br>")) {
        val = val.replace("<br>", "");
        val = val.replace("<br/>", "");
      }
    }
  }
  if (
    props.taskName === "offers List" ||
    props.taskName === "Zero transactions" ||
    props.taskName === "otp success"
  ) {
    val = props.message;
    val = val
      .replace(/<h1>/g, "")
      .replace(/<\/h1>/g, "")
      .replace(/<br>/, "");
  }

  return props.message.indexOf("<p>#SF#") === 0 ? (
    <React.Fragment>
      <HandleMessageParsing
        {...props}
        message={messedMessage.answer}
        style={{ padding: "0 12px 12px 0" }}
      />
      <CardComponent cardJSON={messedMessage.card} />
    </React.Fragment>
  ) : (
    <div
      dangerouslySetInnerHTML={
        val ? { __html: val } : { __html: props.message }
      }
      style={{ ...props.style }} // HACK for ResponseComponent
    ></div>
  );
};

let JSXStringMessage = (props) => {
  try {
    let val = props.message;
    while (val.includes("<br/>") || val.includes("<br>")) {
      val = val.replace("<br>", "");
      val = val.replace("<br/>", "");
    }
    // console.log(props)
    return (
      <JsxParser
        components={{ ActionItem }}
        bindings={{ handleSubmit: props.handleSubmit }}
        jsx={props.sanitizeMessage(val)}
        onError={(error) => {
          console.log(error);
        }}
        showWarnings={true}
      ></JsxParser>
    );
  } catch (error) {
    console.log(error);
    // return <div>Oops! It’s not you. It’s us. Give it another try later, please.</div>;
    return (
      <div>Sorry! Something went wrong. Please try again after sometime.</div>
    );
  }
};

let ListElem = (props) => {
  return (
    <div className="sf-card-header" style={{ padding: 0 }}>
      <ActionItem
        actionLabel={props.e.itemTitle}
        actionValue={props.e.actionText}
        listElemClass="sf-list-elem"
        handleSubmit={props.handleSubmit}
        handleQuickLinkSubmit={props.handleQuickLinkSubmit}
      />
    </div>
  );
};

let ResponseComponent = (props) => {
  return (
    <React.Fragment>
      <div>{props.element.optionInterface.optionTitle}</div>
      {
        <div className="sf-list">
          {props.element.optionInterface.optionList.map((e, i) => {
            return <ListElem key={i} e={e} handleSubmit={props.handleSubmit} />;
          })}
        </div>
      }
    </React.Fragment>
  );
};

function responseToCardJSON(listItems) {
  //COMPLETE THE BELOW
  let res = [];
  listItems.map((e, i) => {
    res.push({
      header: { mainText: e.title, subText: e.description },
      body: { type: e.resourceType, url: e.resourceURL },
      footer: {
        mainText: e.subtitle,
        subText: "",
        action: {
          text: e.linkButtonTitle,
          url: e.linkButtonURL,
        },
      },
      extraInfo: { actionText: e.actionText },
    });
  });

  return res;
}

const RenderCards = (props: any) => {
  return props.cards.map((e, i) => {
    return <SFCard e={e} key={i} handleSubmit={props.handleSubmit} />;
  });
};
//snpplus flow
let HandleCheckBox = (props) => {
  const [checked, setChecked] = useState(true);
  const buttonStyleEnabled = { background: "#003E8D", pointerEvents: "auto" };
  const buttonStyleDisabled = { background: "#a8aad3", pointerEvents: "none" };
  const [buttonStyle, setButtonStyle] = useState(buttonStyleEnabled);
  const CheckTC = styled.div`
    display: flex;
    justify-content: space-evenly;
  `;
  const handleCheck = (ev) => {
    setChecked(!checked);
    if (ev.target.checked) {
      ev.target.parentElement.nextElementSibling.classList.remove("disabled");
    } else {
      ev.target.parentElement.nextElementSibling.classList.add("disabled");
    }
  };
  const handleProceed = (sendData) => {
    let inputString = sendData + "<split>" + sendData;
    window["autosubmit"](inputString);
    document.getElementById("Terms").style.pointerEvents = "none";
    setButtonStyle(buttonStyleDisabled);
  };

  return (
    <div id="Terms">
      <div
        dangerouslySetInnerHTML={{
          __html: props.message.split("#enableCheckBox#")[0],
        }}
        style={{ ...props.style }} // HACK for ResponseComponent
      ></div>
      <CheckTC>
        <input
          checked={checked}
          type="checkbox"
          id="terms-and-conditions"
          onChange={(ev) => handleCheck(ev)}
        />
        <span>
          I agree to the{" "}
          <a
            target="_blank"
            href="https://www.rbl.bank.in/api/v1/doc/document/offer-pdfs/terms-split-n-pay-plus-19-oct-19.pdf"
            style={{ cursor: "pointer" }}
          >
            Terms and Conditions
          </a>
        </span>
      </CheckTC>
      <div
        className="action-elem"
        onClick={() => handleProceed("Lets go ahead with my selection")}
      >
        Lets go ahead with my selection
      </div>
      <div
        className="action-elem"
        onClick={() => handleProceed("I want to explore other EMI Plans")}
      >
        I want to explore other EMI Plans
      </div>
    </div>
  );
};
//health insurance PDF
const LifeInsurancePDF = (props) => {
  // console.log(props)
  useEffect(() => {
    document.querySelectorAll(".disable-item")[0].classList.add("disabled");
    document.querySelectorAll(".disable-item")[1].classList.add("disabled");
  }, []);
  const handleCheck = (ev) => {
    ev.target.parentElement.nextElementSibling.classList.remove("disabled");
    ev.target.parentElement.nextElementSibling.nextElementSibling.classList.remove(
      "disabled"
    );
  };
  const handleProceed = (sendData) => {
    let inputString = sendData + "<split>" + sendData;
    window["autosubmit"](inputString);
    document.getElementById("Terms").style.pointerEvents = "none";
    document.getElementById("Terms").style.opacity = "0.6";
  };
  return (
    <div id="Terms">
      <div>
        Click{" "}
        <a
          onClick={(ev) => handleCheck(ev)}
          href="https://webassets.rbl.bank.in/document/pdfs/dogh-22oct20.pdf"
          target="_blank"
        >
          here
        </a>{" "}
        to read good health declaration.
      </div>
      <div
        className="action-elem disable-item"
        onClick={() => handleProceed("Yes")}
      >
        Yes, I’m in good health
      </div>
      <div
        className="action-elem disable-item"
        onClick={() => handleProceed("No")}
      >
        No, I have pre-existing diseases
      </div>
    </div>
  );
};
//break free switch
let HandleMessageParsing = (props) => {
  switch (typeof props.message) {
    case "object":
      var element = props.message;
      switch (element.responseType) {
        case "RESPONSE_TYPE_3":
          return (
            <ResponseComponent
              element={element}
              {...props}
              handleSubmit={props.handleSubmit}
            />
          );
          break;
        case "LIST":
          return (
            <RenderCards
              cards={responseToCardJSON(element.lists.items)}
              handleSubmit={props.handleSubmit}
            />
          );
          break;
        case "RESPONSE_TYPE_4":
          return (
            <CardComponent cardJSON={responseToCardJSON(element.lists.items)} />
          );
          break;
        case "CAROUSAL":
          return (
            <CardComponent cardJSON={responseToCardJSON(element.lists.items)} />
          );
          break;
        case "SIMPLE":
          return (
            <HandleMessageParsing
              {...props}
              message={element.displayResponse
                .replace(new RegExp("&nbsp;", "g"), "")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")}
            />
          );
          break;
        default:
          return (
            <HandleMessageParsing
              {...props}
              message={element.displayResponse
                .replace(new RegExp("&nbsp;", "g"), "")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")}
            />
          );
      }
      break;

    default: {
      const ImgModal = styled.img`
        width: 200px;
        height: 190px;
        position: relative;
        left: 40px;
        @media (max-width: 1024px) {
          left: 40px;
        }
        @media (max-width: 678px) {
          left: 50px;
        }
        @media (max-width: 425px) {
          left: 32px;
        }
        @media (max-width: 320px) {
          left: 10px;
        }
      `;
      return typeof props.message === "string" ? (
        /**
         * Regex.test with //g flag holds lastIndex
         * https://stackoverflow.com/questions/209732/why-am-i-seeing-inconsistent-javascript-logic-behavior-looping-with-an-alert-v
         * https://drive.google.com/file/d/18lQhivCGyPI2FNfuLKd74N7DKapGah5R/view?usp=sharing
         */

        props.message.includes("#image#") ? ( //xpress and stpl
          <div>
            <div
              dangerouslySetInnerHTML={{
                __html: props.message.split("#image#")[0],
              }}
              style={{ ...props.style }} // HACK for ResponseComponent
            ></div>
            <ImgModal
              onClick={() => {
                props.overlayImageModalToggle(
                  "#ImagePath#" + "#RBLIMG#" + getImg("RBL_EMI.jpg")
                );
              }}
              src={getImg("RBL_EMI.jpg")}
              alt="RBL_EMI"
            ></ImgModal>
            <JSXStringMessage
              {...props}
              message={moreSanitization(
                props.message
                  .split("#image#")[1]
                  .replace(/ class=\\?"Workflow-link\\?"/g, "")
                  .replace(/ class=\\?"Workflow-link\\?"/g, "")
                  .replace(/ class=\\?"wf-summary-confirm\\?"/g, "")
                  .replace(new RegExp("&nbsp;", "g"), "")
                  .replace(/&lt;/g, "<")
                  .replace(/&gt;/g, ">")
                  .replace("</p>", "")
                  .replace("<br>", "")
              )}
            />
          </div>
        ) : props.message.includes("#KYCFileUpload#") ? (
          <KYCFileUpload {...props} />
        ) : props.message.includes("#KYCAppointment#") ? (
          <KYCAppointment isPushBotVisible={props.isPushBotVisible} />
        ) : props.message.includes("#healthpdf#") ? (
          <LifeInsurancePDF {...props} />
        ) : props.message.includes("#enableCheckBox#") ? (
          <HandleCheckBox {...props} />
        ) : props.message.includes("#_#{type") ||
          (props.message.includes('<a href="javascript:autosubmit') &&
            !props.message.includes('class="sf-asbmt"')) ||
          (props.message.includes(
            '<a class="Workflow-link" href="javascript:autosubmit'
          ) &&
            !props.message.includes('class="sf-asbmt"')) ? (
          <JSXStringMessage
            {...props}
            message={moreSanitization(
              props.message
                .replace(/ class=\\?"Workflow-link\\?"/g, "")
                .replace(/ class=\\?"Workflow-link\\?"/g, "")
                .replace(/ class=\\?"wf-summary-confirm\\?"/g, "")
                .replace(new RegExp("&nbsp;", "g"), "")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace("#Logoless#", "")
            )}
          />
        ) : (
          <DangerousMessage
            {...props}
            message={props.message
              .replace(new RegExp("&nbsp;", "g"), "")
              .replace(/&lt;/g, "<")
              .replace(/&gt;/g, ">")
              .replace("#Logoless#", "")
              .replace("#ImagePath#", "")}
          />
        )
      ) : null;
    }
  }
};

function moreSanitization(message) {
  return message.indexOf("<p>#SF#") === 0 ? parseJSON(message) : message;
}

//OverRide the css..
const MessageStyles = (props) => {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
            .msg-wrapper div.msg-user{
                background-color : ${
                  props.styles.botId == "138"
                    ? "rgba(86, 160, 211, 0.27)"
                    : props.styles.secondaryColour
                }
            }
            `,
      }}
    />
  );
};

function calcTheRequiredPadding(wrapper) {
  let messageWrappers = document.getElementsByClassName(
    "sf-message-feather-wrapper"
  ) as HTMLCollectionOf<HTMLElement>;
  if (messageWrappers.length === 0) return null;

  let chatBody = wrapper;
  if (chatBody.offsetHeight > messageWrappers[0].offsetHeight) {
    return null;
  } else return messageWrappers[0].offsetHeight - chatBody.offsetHeight;
}

function returnStructuredExtraData(extraData) {
  if (!extraData.entity) {
    return "";
  }
  var toReturn;
  toReturn =
    "Recognised Information:\nEntity: " +
    extraData.entity +
    "\nIntent: " +
    extraData.intent +
    "\nQuestion: " +
    extraData.question +
    "\nEntity Heirarchy: " +
    extraData.entity_heirarchy +
    "\nSemantics Identified: " +
    extraData.semantics +
    "\nVariations Matched :" +
    extraData.variationMatched +
    "\nIntent Score: " +
    extraData.intent_score +
    "\nIntent Not Match: " +
    extraData.intent_notmatch +
    "\nReverse Intent Score: " +
    extraData.reverseIntentScore +
    "\nReverse Intent Not Match: " +
    extraData.reverseintent_notmatch +
    "\nSemantic Sequence: " +
    extraData.semanticsequence +
    "\nContextEnable: " +
    extraData.entityinContext;
  return toReturn;
}

const ExtraDisambInfos = (props) => {
  return (
    <div>
      {props.extras.map((e, i) => {
        if (e.hasOwnProperty("mask") && e.question.length === 16) {
          e.question = e.question.replace(/.(?=.{4})/g, "X");
        }
        return (
          <span key={i} title={returnStructuredExtraData(e)}>
            <ActionItem
              actionLabel={
                e.question + (e.hasOwnProperty("type") ? " - " + e.type : "")
              }
              actionValue={e.value || e.question}
              handleSubmit={props.handleSubmit}
            />
          </span>
        );
      })}
    </div>
  );
};

const handleViewMore = (ev) => {
  var element = ev.target;
  element.previousSibling.classList.toggle("hide");
  if (element.previousSibling.classList.contains("hide")) {
    element.innerHTML = "Alternate Options";
  } else {
    element.innerHTML = "View Less";
  }
};

const ViewMoreBlock = ({ value, i }) => {
  return (
    <React.Fragment key={i}>
      <div
        dangerouslySetInnerHTML={{ __html: value }}
        id={`view-more-block-${i}`}
        className={`view-more-string hide`}
      />
      <div className={"view-more-click"} onClick={() => handleViewMore(event)}>
        Alternate Options
      </div>
    </React.Fragment>
  );
};

interface IState {
  isMenuVisible: boolean;
  menuIndex: string;
}

class MessageFeather extends Component<IProps, IState> {
  //static contextType = ThemeContext;
  private wrapper: React.RefObject<HTMLInputElement>;

  constructor(props) {
    super(props);
    this.wrapper = React.createRef();
    this.state = {
      isMenuVisible: false,
      menuIndex: "0",
    };
    // console.log("here..",this.props.isPushBotVisible)
  }

  toggleMenu = () => {
    this.setState({
      isMenuVisible: !this.state.isMenuVisible,
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.chatMessages.length != this.props.chatMessages.length ||
      nextProps.isWelcomeScreenVisible != this.props.isWelcomeScreenVisible ||
      nextState.isMenuVisible !== this.state.isMenuVisible ||
      nextProps.userSelectedIFSCCode != this.props.userSelectedIFSCCode
    );
  }
  componentDidMount(): void {
    console.log("Component mounted..");
  }
  componentDidCatch() {
    console.log("Something went wrong!");
  }

  handleMenu = (actionType, index) => {
    if (actionType === "menu") {
      this.toggleMenu();
      this.setState({
        menuIndex: index,
      });
    } else {
      null;
    }
  };

  setWelcomeMessage() {
    //         /pb/lgca - Hi! This is RBL Cares - your personal digital assistant. I'm here to help you apply for a Current Account with us. Let's get started!

    // /pb/lgsa - Hi! This is RBL Cares - your personal digital assistant. I'm here to help you apply for a Savings Account with us. Let's get started!

    // /pb/lgna - Hi! This is RBL Cares - your personal digital assistant. I'm here to help you apply for an NR Account with us. Let's get started!

    // /pb/lgnd - Hi! This is RBL Cares - your personal digital assistant. I'm here to help you apply for an NR Deposit with us. Let's get started!

    // /pb/lgofd - Hi! This is RBL Cares - your personal digital assistant. I'm here to help you apply for a Fixed Deposit with us. Let's get started!

    if (window.location.href.includes("pb/deposit")) {
      return (
        <div className="msg-server">
          Hi! This is RBL Cares - your Digital Assistant to help you earn
          attractive returns by opening a Fixed Deposit/Recurring Deposit with
          us.
        </div>
      );
    } else if (window.location.href.includes("pb/hllead")) {
      return (
        <div className="msg-server">
          Welcome to RBL cares - Your digital assistant for home loan enquiry.
          Let's Chat!
        </div>
      );
    } else if (window.location.href.includes("pb/lgca")) {
      return (
        <div className="msg-server">
          Hi! This is RBL Cares - your personal digital assistant. I'm here to
          help you apply for a Current Account with us. Let's get started!
        </div>
      );
    } else if (window.location.href.includes("pb/lgsa")) {
      return (
        <div className="msg-server">
          Hi! This is RBL Cares - your personal digital assistant. I'm here to
          help you apply for a Savings Account with us. Let's get started!
        </div>
      );
    } else if (window.location.href.includes("pb/lgna")) {
      return (
        <div className="msg-server">
          Hi! This is RBL Cares - your personal digital assistant. I'm here to
          help you apply for an NR Account with us. Let's get started!
        </div>
      );
    } else if (window.location.href.includes("pb/lgnd")) {
      return (
        <div className="msg-server">
          Hi! This is RBL Cares - your personal digital assistant. I'm here to
          help you apply for an NR Deposit with us. Let's get started!
        </div>
      );
    } else if (window.location.href.includes("pb/lgofd")) {
      return (
        <div className="msg-server">
          Hi! This is RBL Cares - your personal digital assistant. I'm here to
          help you apply for a Fixed Deposit with us. Let's get started!
        </div>
      );
    } else if (window.location.href.includes("pb/hosp")) {
      return (
        <div className="msg-server">
          Hi! This is RBL Cares - your personal digital assistant. I'm here to
          help you apply for Hospital Daily Cash Policy which offers you
          guaranteed protection!
        </div>
      );
    } else if (window.location.href.indexOf("pb/ccrew") > -1) {
      return (
        <div
          style={{ display: "none" }}
          className="msg-server"
          dangerouslySetInnerHTML={{
            __html: this.props.chatMessages[0].message,
          }}
        ></div>
      );
    } else {
      return (
        <div
          className="msg-server"
          dangerouslySetInnerHTML={{
            __html: this.props.chatMessages[0].message,
          }}
        ></div>
      );
    }
  }
  //here A*
  sendAnalyticsforQuickLink = (data) => {
    let analyticsData = {
      name: data,
      type: "Quick Link",
      action: "",
      botid: "vYdoWvH2CVMbJOGnAB11VA==",
    };

    Axios.post(wrapperEndPoint.analyticsURL, analyticsData)

      .then((response) => {
        console.log(response); //handle sucess
      })
      .catch((error) => {
        console.log(error); //handle error
      });
  };

  render() {
    return (
      <div className="sf-message-feather-wrapper" ref={this.wrapper}>
        {this.props.isWelcomeScreenVisible ? this.props.children : null}
        {/* {window.location.href.includes('pb/ccso')?"": */}
        <div className="msg-wrapper msg-server-wrapper">
          <div className="msg-server-outer first">
            <MessageStyles styles={this.props.data} />
            {
              this.props.chatMessages[0].message.indexOf("<message>") > 0 ? (
                <React.Fragment>
                  <div
                    className="msg-server"
                    dangerouslySetInnerHTML={{
                      __html:
                        this.props.chatMessages[0].message.split(
                          "<message>"
                        )[0],
                    }}
                  ></div>
                  <div
                    className="msg-server"
                    style={{ marginTop: "10px" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        this.props.chatMessages[0].message.split(
                          "<message>"
                        )[1],
                    }}
                  ></div>
                </React.Fragment>
              ) : (
                <div>{this.setWelcomeMessage()}</div>
              )
              // <div className="msg-server"
              //     dangerouslySetInnerHTML={{ __html: this.props.chatMessages[0].message }}
              // >
              // </div>
            }
          </div>
        </div>
        {/* } */}
        {/* {this.props.isPushBotVisible ? null : ( */}
        <div
          style={{
            position: "absolute",
            width: "0",
            height: "0",
            overflow: "hidden",
          }}
          className="msg-wrapper msg-server-wrapper sf-options"
        >
          {this.props.quickLinks.map((e, i) => {
            // actionItem here**
            return (
              <ActionItem
                key={i}
                onClick={() => {
                  this.handleMenu(e.actionType, e.menuIndex);
                  this.sendAnalyticsforQuickLink(e.actionLabel);
                }}
                actionType={e.actionType}
                actionLabel={e.actionLabel}
                actionValue={e.actionValue}
                handleSubmit={this.props.handleSubmit}
                handleQuickLinkSubmit={this.props.handleQuickLinkSubmit}
              />
            );
          })}
          <WorkflowsMenu
            from={"top"}
            workflowQuestions={this.props.data.workflowQuestions}
            isMenuVisible={this.state.isMenuVisible}
            toggleMenu={this.toggleMenu}
            menuIndex={this.state.menuIndex}
          />
        </div>
        {/* )} */}

        {this.props.chatMessages.map((e, i) => {
          if (i == 0) return;
          // if the message itself contains suggestions
          if (
            !Boolean(e.suggestions) &&
            typeof e.message == "object" &&
            Boolean(e.message.suggestions)
          ) {
            e = {
              ...e,
              message: e.message,
              suggestions: e.message.suggestions,
            };
          }
          if (typeof e.message == "string")
            e = { ...e, message: [...[], e.message] };
          return (
            <React.Fragment key={i}>
              <div
                className={`msg-wrapper msg-${e.messageType}-wrapper`}
                style={{
                  display: `${
                    e.message && e.message[0].indexOf("$AUTOTRIGGERQUERY") > -1
                      ? "none"
                      : ""
                  }`,
                }}
              >
                <div
                  className={`msg-${e.messageType}-outer ${
                    e.key == "preloader" ? "preloader" : ""
                  }`}
                >
                  {e.messageType === "server" &&
                    e.key !== "preloader" &&
                    !e.message[0].includes("#Logoless#") && (
                      <img src={rblLogo} className="server-logo" />
                    )}
                  <div
                    onClick={() => {
                      this.props.overlayImageModalToggle(e.message[0]);
                    }}
                    className={`msg-${e.messageType} ${
                      e.hasOwnProperty("WorkFlowflag") && e.WorkFlowflag
                        ? "WorkFlow"
                        : e.liveAgent
                        ? "liveAgent"
                        : ""
                    }  ${e.key == "preloader" ? "preloader" : ""}`}
                  >
                    {e.message.map((elem, i) => {
                      elem = elem
                        .replace(/&lt;/g, "<")
                        .replace(/&gt;/g, ">")
                        .replace("#ImagePath#", "")
                        .replace("#WithOutQuotesPath#", "");
                      e.viewMoreString = "";
                      let workflowJson;
                      if (elem.includes("<JSONsplitter>")) {
                        workflowJson = elem.split("<JSONsplitter>")[1];
                        elem = elem.split("<JSONsplitter>")[0];
                      }
                      if (elem.includes("JSONsplitter")) {
                        workflowJson = elem.split("JSONsplitter")[1];
                        elem = elem.split("JSONsplitter")[0];
                        // if(workflowJson && workflowJson.includes("##nextBubble##")) {
                        //   let json_data = workflowJson.split('##nextBubble##')[0].replace(/<\/p>/g, '').replace(/<p>/g, '').replace(/<h2>/g, '')
                        //           .replace(/<\/h2>/g, '');
                        //   workflowJson = json_data.replace(/<br>/g, '').replace(/<p>/g, '').replace(/&nbsp;/g, ' ').replace(/<\/p>/g, '')
                        // }
                      }
                      if (elem.includes("<ViewMore>")) {
                        e.viewMoreString = elem.split("<ViewMore>")[1].trim();
                        elem = elem.split("<ViewMore>")[0];
                      }
                      // if(elem.includes("##nextBubble##")) {
                      //   elem = elem.split('##nextBubble##')[0];
                      // }
                      // console.log(e.checkList)
                      return (
                        <React.Fragment key={i}>
                          {i > 0 ? <br /> : null} {/**SOME SPACING */}
                          <HandleMessageParsing
                            message={elem}
                            messageType={e.messageType}
                            sanitizeMessage={MDUtil.sanitizeMessage}
                            handleSubmit={this.props.handleSubmit}
                            e={e}
                            taskName={e.taskName}
                            isPushBotVisible={this.props.isPushBotVisible}
                          />
                          {workflowJson && (
                            <HandleWorkflowJson
                              workflowJson={workflowJson}
                              handleSubmit={this.props.handleSubmit}
                              BbpsFlag={this.props.BbpsFlag}
                              checkBoxJsonData={this.props.checkBoxJsonData}
                              checkBoxFlag={this.props.checkBoxFlag}
                              termsCheckBox={this.props.termsCheckBox}
                              termsCheckBoxFlag={this.props.termsCheckBoxFlag}
                              termsText={this.props.termsText}
                              termsLink={this.props.termsLink}
                              setWorkflowName={this.props.setWorkflowName}
                              showRewardCalender={this.props.showRewardCalender}
                              NoConfirmButton={this.props.NoConfirmButton}
                              overlayRechargeToggle={
                                this.props.overlayRechargeToggle
                              }
                              overlayMessageToggle={
                                this.props.overlayMessageToggle
                              }
                              overlayImageModalToggle={
                                this.props.overlayImageModalToggle
                              }
                              logoutUser={this.props.logoutUser}
                              transactionResponseAarry={
                                this.props.transactionResponseAarry
                              }
                              storeChecklist={this.props.storeChecklist.bind(
                                this
                              )}
                              checkList={e.checkList ? e.checkList : null}
                              overlayIFSCInputToggle={
                                this.props.overlayIFSCInputToggle
                              }
                              userSelectedIFSCCode={
                                this.props.userSelectedIFSCCode
                              }
                              userSelectedBankName={
                                this.props.userSelectedBankName
                              }
                              userSelectedId={this.props.userSelectedId}
                              userSelectedAddress={
                                this.props.userSelectedAddress
                              }
                              isPushBotVisible={this.props.isPushBotVisible}
                              toggleGeneralOverlay={this.props.toggleGeneralOverlay.bind(
                                this
                              )}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}
                    {/* {console.log(e)} */}
                    {e && e.message[0].indexOf("$AUTOTRIGGERQUERY") > -1 ? (
                      <ReSubmit handleSubmit={this.props.handleSubmit} />
                    ) : null}
                    {(e.promptLogin ||
                      e.promptLogin == "logout" ||
                      e.promptLogin === "middleLogin") && (
                      <LoginButton
                        toggleLoginScreen={this.props.toggleLoginScreen}
                        logout={e.promptLogin == "logout"}
                        loginType={e.customInfos[0].EntityName}
                      />
                    )}
                    {/* {
                                                e.taskName!== 'Continue' && i !== this.props.chatMessages.length - 1 && e.WorkFlowflag && e.workflowName && 
                                                <div style={{ display: 'block', textAlign: 'right' }}>
                                                    <Button style={{background:'rgba(66, 104, 203,0.19)',color:'#122a68'}} onClick={() => {
                                                        var chatInputElement:HTMLInputElement = document.querySelector('.sf-chatbot #chatInput') as HTMLInputElement;
                                                        chatInputElement && chatInputElement.classList.remove('sf-mask');
                                                        this.props.handleSubmit(`summary:${e.workflowName}`,true);
                                                    }}>
                                                        <img style={{ marginRight: '5px' }} src={editIcon} /> 
                                                    </Button>
                                                </div>
                                            } */}
                    {this.props.isPushBotVisible ? null : (
                      <div>
                        {" "}
                        {e.viewMoreString && (
                          <ViewMoreBlock i={i} value={e.viewMoreString} />
                        )}
                      </div>
                    )}
                    {/* {
                                                e.viewMoreString && <ViewMoreBlock i={i} value={e.viewMoreString} />
                                            } */}
                    {
                      //Change the customInfos[4]
                      e.extra &&
                      e.extra.length > 0 &&
                      e.customInfos[4].disambFlag &&
                      this.props.data.isInsideAware ? (
                        <ExtraDisambInfos
                          sanitizeMessage={MDUtil.sanitizeMessage}
                          handleSubmit={this.props.handleSubmit}
                          e={e}
                          extras={e.extra}
                        />
                      ) : null
                    }
                  </div>
                  {e.isFeedbackVisible ? (
                    <MessageFeedback
                      data={this.props.data}
                      timeStamp={e.timeStamp}
                      extra={e.extra}
                      message={e.customInfos}
                      messageKey={e.key}
                      messageType={e.messageType}
                      removeFeedbackOption={this.props.removeFeedbackOption}
                    />
                  ) : null}
                </div>
              </div>

              {e.suggestions &&
              e.suggestions != null &&
              e.suggestions.length > 0 &&
              this.props.data.relatedQuestions == "true" &&
              !(
                window.location.href.includes("pb/RBLCares") ||
                this.props.isPushBotVisible
              ) ? (
                // &&
                // !(e && e.message[0].includes("##nextBubble##"))
                <div className="msg-wrapper msg-server-wrapper disamb">
                  <div className="msg-server-outer disamb">
                    <div className="msg-server disamb">
                      <div
                        style={{
                          fontSize: "1.17em",
                          fontWeight: "bold",
                          margin: "1em 0",
                        }}
                      >
                        Related Questions...
                      </div>
                      {e.suggestions.map((e, i) => {
                        return (
                          <span className="disamb-elem" key={i}>
                            <img src={searchIcon} alt="search icon" />
                            <ActionItem
                              key={i}
                              actionLabel={e.displayText}
                              actionValue={e.actionText}
                              actionType={e.Type || e.type}
                              handleSubmit={this.props.handleSubmit}
                            />
                          </span>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ) : null}
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

export default MessageFeather;

export { ExtraDisambInfos };

// {
//     this.props.quickLinks.map((e, i) => {
//         return <ActionItem key={i} onClick={ e.actionType === "menu" ? this.toggleMenu : null} actionType={e.actionType} actionLabel={e.actionLabel} actionValue={e.actionValue} handleSubmit={this.props.handleSubmit} />
//     })
// }
